import { useContext, useEffect } from 'react';

import camelcaseKeys from 'camelcase-keys';
import { getUserInfo } from 'config/requests';
import { APIContext } from 'context/apiContext';

import { useRedirectToLogin } from './useRedirectToLogin';

export function useLoadUser(): { isUserLoaded: boolean } {
  const redirectToLogin = useRedirectToLogin();
  const {
    user: { isLoaded },
    setUser,
  } = useContext(APIContext);

  useEffect(() => {
    if (!isLoaded) {
      getUserInfo()
        .then((res) => {
          setUser({ ...camelcaseKeys(res), isLoaded: true });
        })
        .catch(() => redirectToLogin());
    }
  }, [isLoaded, redirectToLogin, setUser]);

  return { isUserLoaded: isLoaded };
}
